<div class="panel panel-default col-sm-5" style="margin-left: 100px;" id="settingsEmail">
  <div class="panel-heading">SMTP Email Account</div>

    <div class="panel-body">

    <form class="form-horizontal">
      <div class="form-group">
        <label class="control-label col-sm-4">SMTP Server Address</label>
        <div class="col-sm-4"><input class="form-control" type="text" name="smtp_server_address" [(ngModel)]="smtp_server_address"></div>
        <label class="control-label col-sm-1">Port</label>
        <div class="col-sm-3"><input class="form-control" type="text" name="port" [(ngModel)]="port"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-4">Email Address</label>
        <div class="col-sm-8"><input class="form-control" type="text" name="email_address" [(ngModel)]="email_address"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-4">Authentication Required</label>
        <div class="col-sm-4"><div class="checkbox checkbox-inline"><input type="checkbox" name="is_authentication_required" [checked]="is_authentication_required" (click)="authentication_required_clicked()" class="styled"><label for=""></label></div></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-4">Login Id</label>
        <div class="col-sm-8"><input class="form-control" type="text" name="login_id" [(ngModel)]="login_id"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-4">Password</label>
        <div class="col-sm-8"><input class="form-control" type="password" name="password" [(ngModel)]="password"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-4">SSL Required</label>
        <div class="col-sm-4"><div class="checkbox checkbox-inline"><input type="checkbox" name="is_ssl" [checked]="is_ssl" (click)="ssl_clicked()" class="styled"><label></label></div></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-4">TSL Required</label>
        <div class="col-sm-4"><div class="checkbox checkbox-inline"><input type="checkbox" name="is_tls" [checked]="is_tls" (click)="tls_clicked()" class="styled"><label></label></div></div>
      </div>

      <div class="modal-footer">
         <button class="btn btn-default" (click)="showTestEmailSettings()"><i class="fa fa-envelope" aria-hidden="true"></i> TEST EMAIL SETTINGS</button>
         <button class="btn btn-primary" (click)="updateSettingsEmail()"><i class="fa fa-refresh" aria-hidden="true"></i> UPDATE</button>
      </div>

      <div class="test-email" id="emailSettingsTestEmailDiv">
        <div class="row">
          <div class="control-label col-sm-4">
            To Address(es):
          </div>

          <div class="col-sm-8">
            <ng-container *ngFor="let toEmail of toEmails; let i = index">
              <div class="row">
                <div class="col-sm-1">
                  <ng-container *ngIf="i == 0">
                    <button class="btn btn-ef" (click)="addNewToEmailValue()">
                      <i class="fa fa-plus"></i>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="i > 0">
                    <button class="btn btn-default" (click)="removeToEmailValueAtIndex(i)">
                      <i class="fa fa-minus"></i>
                    </button>
                  </ng-container>
                </div>
                <div class="col-sm-11">
                  <input class="form-control" [(ngModel)]="toEmail.value" type="text" [delay]="1000" [ngModelOptions]="{standalone: true}" />
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <button class="btn btn-primary btn-block" (click)="sendTestEmail()"><i class="fa fa-envelope" aria-hidden="true"></i> SEND TEST EMAIL</button>
      </div>

      <div class="test-email" id="emailSettingsBusyPointer">
        <div class='loader'></div>
      </div>

      <div class="test-email" id="emailSettingsError">
         <button class="btn btn-link btn-block" (click)="dismissSendTestEmail()"><i class="fa fa-times" aria-hidden="true"></i> Problem executing function. Test email is missing email address to send to.
         </button>
        </div>

      <div class="test-email" style="display: none" id="emailSettingsSuccess">
        <button class="btn btn-link btn-block" (click)="dismissSendTestEmail()"><i class="fa fa-check" aria-hidden="true"></i> OK, Email Sent!</button>
      </div>

    </form>
  </div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
